const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

function matchesDefault(defaultValue: unknown, candidate: unknown): boolean {
  if (candidate === undefined) return false;
  if (defaultValue === null) return true;
  if (Array.isArray(defaultValue)) return Array.isArray(candidate);
  if (isPlainObject(defaultValue)) return isPlainObject(candidate);
  return typeof candidate === typeof defaultValue;
}

/**
 * Lays a stored payload onto the defaults: only keys the defaults know, and only values whose type
 * matches the default's, so a renamed or retyped field falls back instead of breaking the page.
 */
export function pickStored<T extends Record<string, unknown>>(
  defaults: T,
  stored: unknown,
): { value: T; hasStored: boolean } {
  if (!isPlainObject(stored)) return { value: defaults, hasStored: false };
  const value = { ...defaults };
  for (const key of Object.keys(defaults) as (keyof T & string)[]) {
    if (matchesDefault(defaults[key], stored[key])) value[key] = stored[key] as T[typeof key];
  }
  return { value, hasStored: true };
}
